<template>
  <div class="header fvlr">
    <div><img @click="clear" src="../../assets/images/mercedes-benz-logo-desktop.png" /></div>
    <img v-if="showHomeIcon" class="goHome" @click="goHome" src="../../assets/images/icon-home.png" alt="" />
    <!-- <div class="debug" @click="showDebug">debug</div>
    <PopUp :showPopUp="show" :datas="datas">
      {{ debug.success }}
      <br />
      ==================error===============<br />
      {{ debug.error }}
    </PopUp> -->
  </div>
</template>
<script>
import { reactive, toRefs, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
// import { useStore } from 'vuex'
// import PopUp from '@/components/common/PopUp.vue'
export default {
  // components: {
  //   PopUp
  // },
  setup() {
    // const store = useStore()

    const router = useRouter()
    const route = useRoute()
    const state = reactive({
      showHomeIcon: route.path !== '/SystemMaintenance'
      // show: 0,
      // debug: {},
      // datas: {
      //   title: 0,
      //   content: ''
      // }
    })
    const goHome = () => {
      router.push({ path: '/', query: { event: '回到首页' } })
    }
    const clear = () => {
      sessionStorage.clear()
    }
    // const showDebug = () => {
    //   state.debug = store.state.debug
    //   state.show += 1
    // }
    watch(
      () => route.path,
      n => {
        state.showHomeIcon = n !== '/SystemMaintenance'
      }
    )
    return {
      ...toRefs(state),
      clear,
      goHome
      // showDebug
    }
  }
}
</script>
<style lang="scss" scoped>
.debug {
  margin-right: 20px;
  color: #fff;
}

.header {
  height: 80px;
  width: 100%;
  background-color: #000000;
  position: fixed;
  top: 0;
  z-index: 1000;
  img {
    width: 162px;
    height: 40px;
    margin-left: 20px;
  }
  .goHome {
    height: 26px;
    width: 26px;
    margin-right: 28px;
    // height: 6.4vw;
    // width: 6.4vw;
    // margin-right: 6.4vw;
  }
}
</style>
